<template>
<div class='d-flex align-items-center'>
  <p
    class="m-0"
    v-if="step === 1" 
  >シフトを作成する単位や所属の変更がある場合は、チームの追加変更を行ってください。問題がなければ、右下の次へをクリックしてください。</p>
  <p
    v-if="parseInt(step) === 2"
    class="sub-heading"  
  >シフトを作成する単位や所属の変更がある場合は、チームの追加変更を行ってください。問題がなければ、右下の次へをクリックしてください。</p>
  <p
    v-if="parseInt(step) === 3" 
    class="sub-heading"
  >入退職や休職、職員情報が変更となる場合は、職員の追加変更を行ってください。問題がなければ、右下の次へをクリックしてください。</p>
  <p
    v-if="step === 4" 
    class="sub-heading"
  >追加した職員、または変更した職員について必要に応じて勤務区分の割り当てを行ってください。問題がなければ、右下の次へをクリックしてください。</p>
  <p
    v-if="step === 5" 
    class="sub-heading"
  >勤務区分ごとに、出勤する人数を設定してください。問題がなければ、右下の次へをクリックしてください。<br />
    <span style="font-size: 12px">
      たとえば、2人以上、5人以下を設定した場合、常に2～5人が事業所に出勤しているシフトが作成されます。<br />
      ※一括指定を入力すると、選択した勤務区分の行すべてに反映することができます。
    </span>
  </p>
  <p
    v-if="step === 6"
    class="sub-heading"
  > 職員に対する勤務区分ごとの月あたりの勤務回数を設定してください。問題がなければ、右下の次へをクリックしてください。 </p>
  <p
    v-if="step === 7"
    class="sub-heading"
  >追加した職員、または変更した職員について必要に応じてシフトパターンを設定してください。問題がなければ、右下の次へをクリックしてください。</p>
  <p
    v-if="step === 8"
    class="sub-heading"
  >追加した職員、または変更した職員について必要に応じて組合せを設定してください。問題がなければ、右下の次へをクリックしてください。</p>
  <p
    v-if="step === 9"
    class="sub-heading"
  >シフト作成後、リセットを押すと希望休（希望勤務） 反映後に戻すことができます。</p>  
</div>
</template>
<script>
export default {
  name: 'AutoCreateSubHeading',
  props: {
    step: {
      type: Number,
      default: 0,
    },
  }
}
</script>

<style scope>
.sub-heading {
  width: fit-content;
  margin:0px 0px !important;
}
</style>
